import { ActionTree } from "vuex";
import { SearchConditionState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<SearchConditionState, RootState> = {};
